<template>
  <swiper-container
    component-name="carousel-bath-concept-launcher"
    ref="tpl_root"
    init="false"
    class="w-full"
    events-prefix="swiper-"
  >
    <swiper-slide
      v-for="project in projects"
      class="relative top-0 left-0 overflow-hidden flex justify-center items-center max-h-full"
    >
      <btn
        :title="project.cover.asset.alt"
        :action="{ to: `/bath-concept/${project.slug}` }"
        class="overflow-hidden w-full aspect-1/1 max-h-full bg-skin-muted"
      >
        <media
          v-bind="project.cover.asset"
          class="w-full h-full object-cover group-hover/btn:scale-110 transition-transform duration-1000 ease-in-out"
          :sizes="{
            base: 450,
            phablet: 650,
            tablet: 450,
            laptop: 450,
            desktop: 500,
            extdesktop: 550,
          }"
        />
      </btn>
    </swiper-slide>
  </swiper-container>
</template>

<script setup>
const props = defineProps({
  projects: {
    type: Array,
    required: true,
  },
});
const { width: windowW } = useWindowSize();
const tpl_root = templateRef("tpl_root");

const offset = computed(() => {
  return Math.min(Math.max(24, (windowW.value / 100) * 4.16), 80);
});

const spaceBetween = computed(() => {
  let size;

  if (windowW.value >= 1020) {
    size = Math.min(Math.max(64, (windowW.value / 100) * 6.25), 120);
  } else size = Math.min(Math.max(24, (windowW.value / 100) * 4.16), 80);

  return size;
});

const options = {
  base: {
    min: 0,
    slidesPerView: 1.4,
  },
  phablet: {
    min: 600,
    slidesPerView: 1.6,
  },
  tablet: {
    min: 1020,
    slidesPerView: 2.9,
  },
  laptop: {
    min: 1272,
    slidesPerView: 3.5,
  },
  desktop: {
    min: 1512,
    slidesPerView: 3.9,
  },
  extdesktop: {
    min: 1920,
    slidesPerView: 4.9,
  },
};

function updateOptions() {
  const LEN = props.projects.length;
  if (windowW.value >= options.extdesktop.min) {
    if (LEN > options.extdesktop.slidesPerView) {
      tpl_root.value.slidesOffsetBefore = offset.value;
      tpl_root.value.slidesOffsetAfter = offset.value;
    }
  } else if (windowW.value >= options.desktop.min) {
    if (LEN > options.desktop.slidesPerView) {
      tpl_root.value.slidesOffsetBefore = offset.value;
      tpl_root.value.slidesOffsetAfter = offset.value;
    }
  } else if (windowW.value >= options.laptop.min) {
    if (LEN > options.laptop.slidesPerView) {
      tpl_root.value.slidesOffsetBefore = offset.value;
      tpl_root.value.slidesOffsetAfter = offset.value;
    }
  } else if (windowW.value >= options.tablet.min) {
    if (LEN > options.tablet.slidesPerView) {
      tpl_root.value.slidesOffsetBefore = offset.value;
      tpl_root.value.slidesOffsetAfter = offset.value;
    }
  } else if (windowW.value >= options.phablet.min) {
    if (LEN > options.phablet.slidesPerView) {
      tpl_root.value.slidesOffsetBefore = offset.value;
      tpl_root.value.slidesOffsetAfter = offset.value;
    }
  } else if (LEN > options.base.slidesPerView) {
    tpl_root.value.slidesOffsetBefore = offset.value;
    tpl_root.value.slidesOffsetAfter = offset.value;
  }

  tpl_root.value.spaceBetween =
    props.projects.length > 1 ? spaceBetween.value : 0;
}

useSafeMountedEl(tpl_root, () => {
  Object.assign(tpl_root.value, {
    slidesPerView: options.base.slidesPerView,
    grabCursor: true,
    speed: 450,
    centerInsufficientSlides: true,
    breakpoints: {
      [options.phablet.min]: {
        slidesPerView: options.phablet.slidesPerView,
      },
      [options.tablet.min]: {
        slidesPerView: options.tablet.slidesPerView,
      },
      [options.laptop.min]: {
        slidesPerView: options.laptop.slidesPerView,
      },
      [options.desktop.min]: {
        slidesPerView: options.desktop.slidesPerView,
      },
      [options.extdesktop.min]: {
        slidesPerView: options.extdesktop.slidesPerView,
      },
    },
    on: {
      init() {
        ScrollTrigger.refresh(true);
      },
      resize(swiper) {
        if (tpl_root.value && swiper) {
          updateOptions();
        }
      },
    },
  });

  updateOptions();
  tpl_root.value.initialize();
});
</script>
